import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import {
//   EditorState,
//   convertToRaw,
//   convertFromHTML,
//   convertFromRaw,
//   ContentState,
// } from "draft-js";
// import draftToHtml from "draftjs-to-html";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./HomeOwnerOnboardingDashboard.scss";
import "./Media.scss";

import {
  onFetchOnboardingOrders,
  saveOrderId,
  fetchOnboardingOrderDetails,
  clearOrderDetails,
  onChangeChecklistStatus,
  onAddChecklistNote,
  onUpdateChecklistNote,
  onAddChecklistDocument,
  stopOnboardingLoader,
  clearOrders,
  saveNotaryForm,
  clearConveyanceForm,
  clearSaveConveyanceFormData,
} from "../../../../store/actions/HomeOwnerOnboardingDashboard";
import { ConstructionStages } from "../../ConstructionStages";
import {
  clearConstructionStages,
  fetchPropertyStages,
} from "../../../../store/actions/HomeownerOnboardingComponent";
import VideoPlayer from "../../../Document/VideoPlayer";
import Loader from "../../../Loader";
import { selectAuthenticatedUser } from "../../../../store/selectors/auth";
import AddNote from "./AddNote";
import AddDocument from "./AddDocument";
import Checklist from "./Checklist";
import Col from "../../../Col";
import Row from "../../../Row";
import { upload } from "../../../../helpers/upLoadHelper";
import Button from "../../../Button";
import { selectFormLoader } from "../../../../store/selectors/FormLoader";

import DocumentTitle from "react-document-title";
import TextEditor from "../../../Editor/Editor";
import OrdersList from "./OrdersList";
import KeycontactsList from "./KeycontactsList";
import FaqsList from "./FaqsList";
import { fetchtAllowedTabList } from "../../../../store/actions/tabSelections";
import {
  clearActiveTab,
  clearActiveSuiteTab,
  clearActiveCatalogTab,
  clearActiveContactTab,
} from "../../../../store/actions/activeTab";
import FeedBack from "../../../FeedBack";
import { USER_ROLES } from "../../../../common/constants";
import { checkMediaType } from "../../../../helpers/CommonHelpers";
class HomeOwnerOnboardingDashboard extends Component {
  state = {
    isOpenPopup: false,
    isOpenDocumentPopup: false,
    note: "",
    originalNote: "",
    convertedNote: "",
    checklistId: "",
    documents: [],
    selectedFaqsId: [],
    lawFirm: null,
    lawyer: null,
    maillingAddress: null,
    email: null,
    phone: null,
    fax: null,
    financialInstitution: null,
    orderId: null,
    imageLoading: false,
    feedBackReportPopup: false,
  };

  componentDidMount() {
    const {
      onFetchOnboardingOrders,
      onFetchPropertyStages,
      clearConstructionStages,
      clearOrderDetails,
      clearOrders,
      currentUserSuite,
      stopOnboardingLoader,
      clearConveyanceForm,
      onboardingData,
      clearConveyanceFormData,
      fetchtAllowedTabList,
    } = this.props;
    stopOnboardingLoader();
    // clearOrders();
    clearConstructionStages();
    clearOrderDetails();
    // onFetchOnboardingOrders(currentUserSuite.propertyId);
    clearConveyanceForm();
    // clearConveyanceFormData()
    onFetchPropertyStages(currentUserSuite.propertyId);
    fetchtAllowedTabList(currentUserSuite.propertyId);

    //Modified By: Anjali
    //Modified On: 14-11-2023
    //Jira-Id: https://bosframework.atlassian.net/browse/JUN-3777
    //Reason: Multiple feedbacks can be submitted using single link
    const { user } = this.props;

    if (
      user &&
      user.roles &&
      user.roles.length > 0 &&
      user.roles[0].role.name?.toUpperCase() ===
        USER_ROLES.HOME_OWNER.toUpperCase()
    ) {
      let isfeedBackReportPopup = localStorage.getItem(
        "IsHomerNavigatFromFeedBackTemplate"
      );
      if (
        isfeedBackReportPopup !== undefined &&
        isfeedBackReportPopup !== null &&
        isfeedBackReportPopup != ""
      ) {
        // setFeedBackReportPopup(true);
        this.setState({ feedBackReportPopup: true });
      }
    }
  }

  async componentDidUpdate(prevProps) {
    const { currentUserSuite: prevCurrentUserSuite } = prevProps;
    const {
      onFetchOnboardingOrders,
      onFetchPropertyStages,
      clearConstructionStages,
      clearOrderDetails,
      clearOrders,
      currentUserSuite,
      clearConveyanceForm,
      clearConveyanceFormData,
      user,
    } = this.props;
    if (prevCurrentUserSuite.id !== currentUserSuite.id) {
      clearOrders();
      clearConstructionStages();
      clearOrderDetails();
      clearConveyanceForm();
      // clearConveyanceFormData()
      onFetchOnboardingOrders(
        currentUserSuite.propertyId,
        currentUserSuite.id,
        user.id
      );
      onFetchPropertyStages(currentUserSuite.propertyId);
    }
  }
  componentWillMount() {
    const {
      clearActiveTab,
      clearActiveSuiteTab,
      clearActiveCatalogTab,
      clearActiveContactTab,
    } = this.props;
    clearActiveTab();
    clearActiveSuiteTab();
    clearActiveCatalogTab();
    clearActiveContactTab();
  }
  onFetchOrderDetails = (orderId) => {
    this.setState({
      lawFirm: null,
      lawyer: null,
      maillingAddress: null,
      email: null,
      phone: null,
      fax: null,
      financialInstitution: null,
      orderId: orderId,
    });
    const {
      onSaveOrderId,
      onFetchOnboardingOrderDetails,
      currentUserSuite,
      clearConveyanceForm,
      user,
      onboardingData,
      clearConveyanceFormData,
    } = this.props;
    clearConveyanceFormData();
    onSaveOrderId(orderId);
    onFetchOnboardingOrderDetails(
      currentUserSuite.propertyId,
      orderId,
      currentUserSuite.id,
      user.id
    );
    this.setState({ selectedFaqsId: [] });
    clearConveyanceForm();
  };
  onChangeChecklistStatus = (data) => {
    const { onChangeChecklistStatus, user } = this.props;
    let params = {
      userId: user.id,
      suiteOnBoardingChecklist: [
        {
          id: data.id,
          ischecked: !data.ischecked,
        },
      ],
    };
    onChangeChecklistStatus(params);
  };
  onDeleteCreatedDoc = (doc) => {
    const { onDeleteChecklistDoc, user, currentUserSuite } = this.props;
    let params = {
      userId: user.id,
      urls: [
        {
          id: doc.id,
          url: doc.url,
          isdeleted: true,
        },
      ],
      checklistId: doc.checklistId,
      suiteId: currentUserSuite.id,
    };
    onDeleteChecklistDoc(params, "delete");
  };
  onUpdateDeleteChecklistNote = (note, type) => {
    const { onDeleteChecklistNote } = this.props;
    if (type === "update") {
      let summaryText;
      let editorState =
        // note && note.description && note.description.hasOwnProperty("blocks")
        //   ? EditorState.createWithContent(
        //       convertFromRaw(JSON.parse(note.description))
        //     )
        //   : EditorState.createEmpty();
        note.description ? note.description : "";
      summaryText = note.description.replace(/<[^>]+>/g, "");
      // if (note.description) {
      //   const blocksFromHTML = convertFromHTML(note.description);
      //   const cstate = ContentState.createFromBlockArray(
      //     blocksFromHTML.contentBlocks,
      //     blocksFromHTML.entityMap
      //   );
      //   editorState = EditorState.createWithContent(cstate);

      //   summaryText = note.description.replace(/<[^>]+>/g, "");
      // }
      this.setState({
        noteId: note.id,
        checklistId: note.checklistId,
        note: editorState,
        originalNote: note.description,
        convertedNote: summaryText,
        isOpenPopup: true,
      });
    } else {
      onDeleteChecklistNote();
    }
  };
  onAddNote = (type) => {
    const { onAddChecklistNote, onUpdateChecklistNote, user } = this.props;
    if (type === "close") {
      this.setState({
        isOpenPopup: false,
        checklistId: "",
        note: "",
        originalNote: "",
        convertedNote: "",
        noteId: "",
      });
    } else {
      let params = {
        userId: user.id,
        description: this.state.originalNote,
        checklistId: this.state.checklistId,
      };
      if (this.state.noteId) {
        params.id = this.state.noteId;
        onUpdateChecklistNote(params);
      } else {
        onAddChecklistNote(params);
      }
      this.setState({
        isOpenPopup: false,
        checklistId: "",
        note: "",
        originalNote: "",
        convertedNote: "",
        noteId: "",
      });
    }
  };
  onSetNote = (editorState) => {
    // const contentState = editorState.getCurrentContent();
    // let convertToText = draftToHtml(convertToRaw(contentState));
    let convertToText = editorState;
    let summaryText = convertToText.replace(/<[^>]+>/g, "");
    this.setState({
      note: editorState,
      originalNote: editorState,
      convertedNote: summaryText,
    });
  };
  uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile);
    let object = {
      Url: imageUrl,
    };
    callback(object);
  };

  handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];
    for (let i = 0; i < selectedImage.length; i++) {
      await this.uploadimg(selectedImage[i], (imgData) => {
        uploadImages.push(imgData);
      });
    }
    callback(uploadImages);
  };
  onAddDocument = async (type) => {
    const { onAddChecklistDocument, user, currentUserSuite } = this.props;
    const { documents, checklistId } = this.state;
    if (type === "close") {
      this.setState({
        isOpenDocumentPopup: false,
        checklistId: "",
        documents: [],
      });
    } else {
      this.setState({ imageLoading: true });
      let params = {};
      let attachments = [];
      await this.handleMultipleUpload(documents, function (resObj) {
        attachments = resObj;
      });
      this.setState({ imageLoading: false });
      params = {
        userId: user.id,
        urls: attachments,
        checklistId: checklistId,
        suiteId: currentUserSuite.id,
      };
      onAddChecklistDocument(params);
      this.clearData();
    }
  };
  clearData = () => {
    this.setState({
      isOpenDocumentPopup: false,
      documents: [],
      checklistId: "",
    });
  };
  onSelectDocuments = (file) => {
    this.setState({
      documents: [...this.state.documents, ...file],
    });
  };
  onDeleteDoc = (file) => {
    let data = this.state.documents.filter((doc) => doc !== file);
    this.setState({
      documents: data,
    });
  };
  handleSelectFaqs = (faqId) => {
    let selectedFaqsId = this.state.selectedFaqsId;
    let faqObj = selectedFaqsId.filter((fId) => fId === faqId)[0];
    if (faqObj) {
      selectedFaqsId = selectedFaqsId.filter((fId) => fId !== faqObj);
    } else {
      selectedFaqsId = [...selectedFaqsId, faqId];
    }
    this.setState({ selectedFaqsId });
  };

  callSaveNotaryForm = (orderID) => {
    const {
      onboardingData,
      currentUserSuite,
      saveNotaryForm,
      onFetchOnboardingOrderDetails,
      user,
    } = this.props;
    let details = onboardingData.orderDetails;
    const validEmailRegex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

    if (
      this.state.lawFirm === null &&
      this.state.lawyer === null &&
      this.state.maillingAddress === null &&
      this.state.email === null &&
      this.state.phone === null &&
      this.state.fax === null &&
      this.state.financialInstitution === null
    ) {
      alert("Please provide information before submitting form.");
    } else if (
      this.state.lawFirm === "" &&
      this.state.lawyer === "" &&
      this.state.maillingAddress === "" &&
      this.state.email === "" &&
      this.state.phone === "" &&
      this.state.fax === null &&
      this.state.financialInstitution === ""
    ) {
      alert("Please provide information before submitting form.");
    } else {
      if (this.state.email) {
        if (!validEmailRegex.test(this.state.email.toLowerCase())) {
          alert("Please enter a valid email address.");
        } else {
          let params = {
            LawFirmNotary:
              this.state.lawFirm != null
                ? this.state.lawFirm
                : onboardingData.fetchConveyanceFormData.lawFirmNotary,
            LawyerNotaryContactName:
              this.state.lawyer != null
                ? this.state.lawyer
                : onboardingData.fetchConveyanceFormData
                    .lawyerNotaryContactName,
            MailingAddress:
              this.state.maillingAddress != null
                ? this.state.maillingAddress
                : onboardingData.fetchConveyanceFormData.mailingAddress,
            Email:
              this.state.email != null
                ? this.state.email
                : onboardingData.fetchConveyanceFormData.email,
            Phone:
              this.state.phone != null
                ? this.state.phone
                : onboardingData.fetchConveyanceFormData.phone,
            Fax:
              this.state.fax != null
                ? this.state.fax
                : onboardingData.fetchConveyanceFormData.fax,
            FinancialInstitutionBank:
              this.state.financialInstitution != null
                ? this.state.financialInstitution
                : onboardingData.fetchConveyanceFormData
                    .financialInstitutionBank,
            SuiteOnboardingId: details.id,
            SuiteId: currentUserSuite.id,
            UserId: user.id,
          };
          if (
            onboardingData.fetchConveyanceFormData.id !== "" &&
            onboardingData.fetchConveyanceFormData.id !== null
          ) {
            params.id = onboardingData.fetchConveyanceFormData.id;
          }
          //console.log('params',params)
          saveNotaryForm(params);
          //onFetchOnboardingOrderDetails(currentUserSuite.propertyId, this.state.orderId || orderID, currentUserSuite.id, user.id);
        }
      } else {
        let params = {
          LawFirmNotary:
            this.state.lawFirm != null
              ? this.state.lawFirm
              : onboardingData.fetchConveyanceFormData.lawFirmNotary,
          LawyerNotaryContactName:
            this.state.lawyer != null
              ? this.state.lawyer
              : onboardingData.fetchConveyanceFormData.lawyerNotaryContactName,
          MailingAddress:
            this.state.maillingAddress != null
              ? this.state.maillingAddress
              : onboardingData.fetchConveyanceFormData.mailingAddress,
          Email:
            this.state.email != null
              ? this.state.email
              : onboardingData.fetchConveyanceFormData.email,
          Phone:
            this.state.phone != null
              ? this.state.phone
              : onboardingData.fetchConveyanceFormData.phone,
          Fax:
            this.state.fax != null
              ? this.state.fax
              : onboardingData.fetchConveyanceFormData.fax,
          FinancialInstitutionBank:
            this.state.financialInstitution != null
              ? this.state.financialInstitution
              : onboardingData.fetchConveyanceFormData.financialInstitutionBank,
          SuiteOnboardingId: details.id,
          SuiteId: currentUserSuite.id,
          UserId: user.id,
        };
        if (
          onboardingData.fetchConveyanceFormData.id !== "" &&
          onboardingData.fetchConveyanceFormData.id !== null
        ) {
          params.id = onboardingData.fetchConveyanceFormData.id;
        }
        //console.log('params',params)
        saveNotaryForm(params);
        //onFetchOnboardingOrderDetails(currentUserSuite.propertyId, this.state.orderId || orderID, currentUserSuite.id, user.id);
      }
    }
  };

  render() {
    const { onboardingData, constructionStages, fetchConveyanceFormData } =
      this.props;
    let details = onboardingData.orderDetails;
    let orderID = onboardingData.orderId;
    let lawFirm = onboardingData.fetchConveyanceFormData.lawFirmNotary;
    let lawyer = onboardingData.fetchConveyanceFormData.lawyerNotaryContactName;
    let maillingAddress = onboardingData.fetchConveyanceFormData.mailingAddress;
    let emails = onboardingData.fetchConveyanceFormData.email;
    let phones = onboardingData.fetchConveyanceFormData.phone;
    let faxs = onboardingData.fetchConveyanceFormData.fax;
    let financialInstitution =
      onboardingData.fetchConveyanceFormData.financialInstitutionBank;
    const conveyanceFormId = onboardingData.fetchConveyanceFormData.id;
    const { selectedFaqsId } = this.state;
    let summary = details.summary
      ? details.summary.replace(/<[^>]+>/g, "")
      : "";
    let videoSummary = details.videoSummary
      ? details.videoSummary.replace(/<[^>]+>/g, "")
      : "";

    let vSummary =
      // details.videoSummary && details.videoSummary.hasOwnProperty("blocks")
      //   ? EditorState.createWithContent(
      //       convertFromRaw(JSON.parse(details.videoSummary))
      //     )
      //   : EditorState.createEmpty();
      details.videoSummary ? details.videoSummary : "";
    let summaryText =
      // details.summary && details.summary.hasOwnProperty("blocks")
      //   ? EditorState.createWithContent(
      //       convertFromRaw(JSON.parse(details.summary))
      //     )
      //   : EditorState.createEmpty();
      details.summary ? details.summary : "";
    // if (details.videoSummary) {
    //   const blocksFromHTML = convertFromHTML(details.videoSummary);
    //   const cstate = ContentState.createFromBlockArray(
    //     blocksFromHTML.contentBlocks,
    //     blocksFromHTML.entityMap
    //   );
    //   vSummary = EditorState.createWithContent(cstate);
    // }

    // if (details.summary) {
    //   const blocksFromHTML = convertFromHTML(details.summary);
    //   const cstate = ContentState.createFromBlockArray(
    //     blocksFromHTML.contentBlocks,
    //     blocksFromHTML.entityMap
    //   );
    //   summaryText = EditorState.createWithContent(cstate);
    // }
    const theme = localStorage.getItem("theme");
    return (
      <DocumentTitle
        title={
          theme === "Shape"
            ? `SHAPE | ${"TCOL Dashboard"} `
            : `${"Homeowner Onboarding Dashboard"} | juniper`
        }
      >
        <div class="header_section">
          {this.state.feedBackReportPopup &&
            details.suiteOnBoardingFAQs &&
            details.suiteOnBoardingFAQs.length === 0 && <FeedBack />}
          <div class="header_box">
            <div class="configure_heading">
              {this.props.onboardingData.orderDetails &&
              this.props.onboardingData.orderDetails.suiteOnBoardingTitle ? (
                <h2
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    fontSize: 25,
                    fontWeight: "bold",
                  }}
                >
                  {this.props.onboardingData.orderDetails.suiteOnBoardingTitle}
                </h2>
              ) : (
                <h2
                  style={{
                    marginTop: 0,
                    marginBottom: 0,
                    fontSize: 25,
                    fontWeight: "bold",
                  }}
                >
                  Homeowner Information
                </h2>
              )}
            </div>
          </div>
          {(onboardingData && onboardingData.fetchDetailsLoading) ||
          this.state.imageLoading ? (
            <Loader center={true} />
          ) : null}

          <OrdersList
            onboardingData={onboardingData}
            onFetchOrderDetails={this.onFetchOrderDetails}
          />
          {details && details.id ? (
            <>
              <div className="mainRow mt-20">
                <div
                  className="videoDiv"
                  style={{
                    width:
                      (details.suiteOnboardingKeyInformation.length === 0 &&
                        "100%") ||
                      (!details.video &&
                        !(videoSummary && videoSummary.trim()) &&
                        "0%"),
                  }}
                >
                  {details.video ? (
                    <>
                      <div className="playVideo" style={{textAlign: 'center', background:'#f5f5f5'}}>
                        {checkMediaType(details.video, [".mov", ".mp4", "iframe"]) ? (
                          <VideoPlayer url={details.video} />
                        ) : (
                          <img className="limitHeight" src={details.video} />
                        )}
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  {videoSummary && videoSummary.trim() ? (
                    <div className="videoDetails">
                      <div
                        className="videoSummaryScroll"
                        style={{ padding: 10 }}
                      >
                        <TextEditor
                          editorState={vSummary}
                          readOnly={true}
                          toolbarHidden={true}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
                {details &&
                  details.suiteOnboardingKeyInformation &&
                  details.suiteOnboardingKeyInformation.length > 0 && (
                    <KeycontactsList
                      details={details}
                      videoSummary={videoSummary}
                      summary={summary}
                    />
                  )}
              </div>
              {constructionStages && constructionStages.length > 0 ? (
                <ConstructionStages constructionStages={constructionStages} />
              ) : null}
              {details.suiteOnBoardingChecklist &&
              details.suiteOnBoardingChecklist.length > 0 ? (
                <div className="mainRow mt-40">
                  <div className="checklist">
                    <h2>Checklist</h2>
                    <Checklist
                      user={this.props.user}
                      checklist={details.suiteOnBoardingChecklist}
                      onChangeChecklistStatus={this.onChangeChecklistStatus}
                      onDeleteCreatedDoc={this.onDeleteCreatedDoc}
                      isAddNote={(cl) =>
                        this.setState({ isOpenPopup: true, checklistId: cl.id })
                      }
                      isAddDocument={(cl) =>
                        this.setState({
                          isOpenDocumentPopup: true,
                          checklistId: cl.id,
                        })
                      }
                      onUpdateDeleteChecklistNote={
                        this.onUpdateDeleteChecklistNote
                      }
                    />
                  </div>
                </div>
              ) : null}

              {/* Conveyance form */}
              {details.isLegalRepresentativeInformation ? (
                <div className="mainRow mt-20">
                  <div className="checklist">
                    <h2>Legal Representative Form</h2>
                    {/* <form> */}
                    <div className="legalRepresentatives">
                      <Row>
                        <Col xs="12" md="4">
                          <label>Law Firm / Notary :</label>
                          <input
                            className="form-control"
                            type="text"
                            name=""
                            placeholder="Law Firm/ Notary"
                            value={
                              this.state.lawFirm != null
                                ? this.state.lawFirm
                                : lawFirm
                            }
                            onChange={(e) => {
                              //console.log('e.target.value',e.target.value)
                              this.setState({ lawFirm: e.target.value });
                            }}
                            required
                            // disabled = {!homeownerOnboardingFormData?.propertyId}
                          />
                        </Col>
                        <Col xs="12" md="4">
                          <label>Legal Representative Contact Name :</label>
                          <input
                            className="form-control"
                            type="text"
                            name=""
                            placeholder="Lawyer / Notary Contact Name"
                            value={
                              this.state.lawyer != null
                                ? this.state.lawyer
                                : lawyer
                            }
                            onChange={(e) =>
                              this.setState({ lawyer: e.target.value })
                            }
                            required
                          />
                        </Col>
                        <Col xs="12" md="4">
                          <label>Legal Representative Mailing Address :</label>
                          <input
                            className="form-control"
                            type="text"
                            name=""
                            placeholder="Mailing Address"
                            value={
                              this.state.maillingAddress != null
                                ? this.state.maillingAddress
                                : maillingAddress
                            }
                            onChange={(e) =>
                              this.setState({ maillingAddress: e.target.value })
                            }
                            required
                          />
                        </Col>
                        <Col xs="12" md="4">
                          <label>Legal Representative Email :</label>
                          <input
                            className="form-control"
                            type="email"
                            name=""
                            placeholder="Email"
                            value={
                              this.state.email != null
                                ? this.state.email
                                : emails
                            }
                            onChange={(e) =>
                              this.setState({ email: e.target.value })
                            }
                            required
                          />
                        </Col>
                        <Col xs="12" md="4">
                          <label>Legal Representative Phone :</label>
                          <input
                            className="form-control"
                            type="text"
                            name=""
                            placeholder="Phone"
                            value={
                              this.state.phone != null
                                ? this.state.phone
                                : phones
                            }
                            onChange={(e) =>
                              this.setState({ phone: e.target.value })
                            }
                            required
                          />
                        </Col>
                        <Col xs="12" md="4">
                          <label>Legal Representative Fax :</label>
                          <input
                            className="form-control"
                            type="text"
                            name=""
                            placeholder="Fax"
                            value={
                              this.state.fax != null ? this.state.fax : faxs
                            }
                            onChange={(e) =>
                              this.setState({ fax: e.target.value })
                            }
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" md="12">
                          <h4>
                            Mortgage Financing Information (if applicable){" "}
                          </h4>
                          <label>Financial Institution / Bank :</label>
                          <input
                            className="form-control financialInstitution"
                            type="text"
                            name=""
                            placeholder="Financial Institution / Bank "
                            value={
                              this.state.financialInstitution != null
                                ? this.state.financialInstitution
                                : financialInstitution
                            }
                            onChange={(e) => {
                              this.setState({
                                financialInstitution: e.target.value,
                              });
                              financialInstitution =
                                this.state.financialInstitution;
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col xs="12" md="12">
                          <div className="text-right">
                            {this.props.user.roles[0].role.name !==
                            "Realtor" ? (
                              <Button
                                onClick={() => this.callSaveNotaryForm(orderID)}
                                color="teal"
                                size="small"
                                label={
                                  this.props.loader
                                    ? "wait.."
                                    : conveyanceFormId === ""
                                    ? "submit"
                                    : "re-submit"
                                }
                              />
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    </div>
                    {/* </form> */}
                  </div>
                </div>
              ) : null}

              {/*End of Conveyance form */}

              {details.suiteOnBoardingFAQs &&
                details.suiteOnBoardingFAQs.length > 0 && (
                  <FaqsList
                    suiteOnBoardingFAQs={details.suiteOnBoardingFAQs}
                    selectedFaqsId={selectedFaqsId}
                    handleSelectFaqs={this.handleSelectFaqs}
                  />
                )}

              {details &&
              details.suiteOnBoardingOffers &&
              details.suiteOnBoardingOffers.length > 0 ? (
                <div className="mainRow mt-20">
                  <div className="checklist">
                    <h2>Offers</h2>
                    <div className="offersSection">
                      {details &&
                      details.suiteOnBoardingOffers &&
                      details.suiteOnBoardingOffers.length > 0 ? (
                        <Carousel autoPlay={false} showThumbs={false}>
                          {details.suiteOnBoardingOffers.map((offer) => {
                            return (
                              <div className="offersDiv">
                                <div className="leftImg">
                                  <img src={offer.logo} alt="" />
                                </div>
                                <div className="offersContent">
                                  <p
                                    style={{ color: "#000", fontWeight: "600" }}
                                  >
                                    {offer.name}
                                  </p>
                                  <TextEditor
                                    editorState={offer.description}
                                    readOnly={true}
                                    toolbarHidden={true}
                                  />
                                  <a
                                    href={offer.linkName}
                                    target="_blank"
                                    style={{ color: "#000", float: "left" }}
                                  >
                                    {offer.linkName}
                                  </a>
                                </div>
                              </div>
                            );
                          })}
                        </Carousel>
                      ) : (
                        <div style={{ padding: "10px", textAlign: "center" }}>
                          No offers found.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
            </>
          ) : null}
          {this.state.isOpenPopup ? (
            <AddNote
              data={this.state}
              onAddNote={this.onAddNote}
              onSetNote={this.onSetNote}
            />
          ) : null}

          {this.state.isOpenDocumentPopup ? (
            <AddDocument
              data={this.state}
              onAddDocument={(type) => this.onAddDocument(type)}
              onSelectDocuments={this.onSelectDocuments}
              onDeleteDoc={this.onDeleteDoc}
              imageLoading={this.state.imageLoading}
            />
          ) : null}
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => ({
  user: selectAuthenticatedUser(state),
  onboardingData: state.onboardingData,
  constructionStages: state.constructionStages,
  loader: selectFormLoader(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchOnboardingOrders: onFetchOnboardingOrders,
      onSaveOrderId: saveOrderId,
      onFetchOnboardingOrderDetails: fetchOnboardingOrderDetails,
      onFetchPropertyStages: fetchPropertyStages,
      clearConstructionStages: clearConstructionStages,
      clearOrderDetails: clearOrderDetails,
      clearOrders: clearOrders,
      onChangeChecklistStatus: onChangeChecklistStatus,
      onAddChecklistNote: onAddChecklistNote,
      onAddChecklistDocument: onAddChecklistDocument,
      stopOnboardingLoader: stopOnboardingLoader,
      onDeleteChecklistDoc: onAddChecklistDocument,
      onUpdateChecklistNote: onUpdateChecklistNote,
      saveNotaryForm: saveNotaryForm,
      clearConveyanceForm: clearConveyanceForm,
      clearConveyanceFormData: clearSaveConveyanceFormData,
      fetchtAllowedTabList: fetchtAllowedTabList,
      clearActiveTab: clearActiveTab,
      clearActiveSuiteTab: clearActiveSuiteTab,
      clearActiveCatalogTab: clearActiveCatalogTab,
      clearActiveContactTab: clearActiveContactTab,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeOwnerOnboardingDashboard);
